import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useClickStore } from '../store/clickStore.js';
import { useShallow } from 'zustand/react/shallow';

export default function HighlightedObject() {
  const meshRef = useRef();

  const { objectDetailsObject, clickType } = useClickStore(
    useShallow((state) => ({
      objectDetailsObject: state.objectDetailsObject,
      clickType: state.clickType,
    }))
  );

  useFrame(() => {
    if (meshRef.current && objectDetailsObject && clickType === 'info' && objectDetailsObject.geometry) {
      const time = Date.now() * 0.001;
      meshRef.current.material.opacity = 0.6 + Math.sin(time * 4) * 0.4;
      meshRef.current.position.copy(objectDetailsObject.position);
      meshRef.current.scale.copy(objectDetailsObject.scale);
      meshRef.current.rotation.copy(objectDetailsObject.rotation);
    }
  });

  if (clickType !== 'info' || !objectDetailsObject || !objectDetailsObject.geometry) {
    return null;
  }

  return (
    <mesh ref={meshRef}>
      <primitive object={objectDetailsObject.geometry.clone()} />
      <meshBasicMaterial color="#FFD700" transparent opacity={0.7} side={2} wireframe={false} />
    </mesh>
  );
}
